class KeyViolationError extends Error {
    constructor({level = KeyViolationError.INFO, message = ''}) {
        super(message);
        this.level = level;
    }

    static inform(error) {
        console[error.level](error);
    }
}

KeyViolationError.LEVEL = {
    INFO: 'info',
    WARN: 'warn',
    ERROR: 'error'
};

module.exports = KeyViolationError;